import apiFetch from '../apiFetch'

export default function (token) {

  return apiFetch({ endPoint: 'Dossier/GetLastAccessedDossier', method: 'GET', body: null, token: token })
}
